export const DIMENSION_UNIT = [
  {
    label: 'cm',
    value: 'cm'
  },
  {
    label: 'in',
    value: 'in'
  },
  {
    label: 'ft',
    value: 'ft'
  }
];

export const WEIGHT_UNIT = [
  {
    value: 'g',
    label: 'g'
  },
  {
    value: 'Kgs',
    label: 'Kgs'
  },
  {
    value: 'Liter',
    label: 'Liter'
  },
  {
    value: 'Metriction',
    label: 'Metriction'
  }
];

export const PACKAGE_METHOD = [
  {
    value: 'Unnecessary',
    label: 'Unnecessary'
  },
  {
    value: 'Carton box',
    label: 'Carton box'
  },
  {
    value: 'Poly mailer',
    label: 'Poly mailer'
  },
  {
    value: 'Compression',
    label: 'Compression'
  },
  {
    value: 'Airpack',
    label: 'Airpack'
  },
  {
    value: 'Icepack',
    label: 'Icepack'
  },
  {
    value: 'Envelope',
    label: 'Envelope'
  },
  {
    value: 'Bubble wrap',
    label: 'Bubble wrap'
  },
  {
    value: 'Direct input',
    label: 'Direct input'
  }
];

export const STORAGE_METHOD = [
  {
    value: 'General',
    label: 'General'
  },
  {
    value: 'Refrigerated',
    label: 'Refrigerated'
  },
  {
    value: 'Frozen',
    label: 'Frozen'
  },
  {
    value: 'Dangerous',
    label: 'Dangerous'
  },
  {
    value: 'Long',
    label: 'Long'
  },
  {
    value: 'Clean',
    label: 'Clean'
  },
  {
    value: 'Liquid',
    label: 'Liquid'
  },
  {
    value: 'Direct input',
    label: 'Direct input'
  }
];

export const GENERAL_SELECT = [
  {
    value: 'YES',
    label: 'YES'
  },
  {
    value: 'NO',
    label: 'NO'
  }
];

export const DANGEROU_GOOD = [
  {
    value: 1,
    label: 'YES'
  },
  {
    value: 0,
    label: 'NO'
  }
];

export const LOT_SELECT = [
  {
    value: 'YES',
    label: 'YES'
  },
  {
    value: 'NO',
    label: 'NO'
  },
  {
    value: 'Direct input',
    label: 'Direct input'
  }
];

export const SHIPMENT_METHOD = [
  { label: 'Air | Carrier', value: 'AIR' },
  { label: 'Ocean', value: 'Ocean' }
];

export const AIR_SELECT = [
  {
    value: 'Korea Post',
    label: 'Korea Post'
  },
  {
    value: 'Fedex',
    label: 'Fedex'
  },
  {
    value: 'DHL',
    label: 'DHL'
  },
  {
    value: 'Direct input',
    label: 'Direct input'
  }
];
